import styled from 'typed-emotion'

export const Root = styled.div`
  margin-top: 8px;
  max-width: 432px;
  padding: 16px;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(0, 0, 0, 0.05);
`

export const Header = styled.div`
  margin-bottom: 12px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors._primary.fadeOut(0.35).toString()};
`

export const Body = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;

  @media (max-width: 420px) {
    flex-direction: column;
    align-items: stretch;
  }
`

export const Icon = styled.img`
  width: 64px;
  height: 64px;
  border-radius: 16px;
  object-fit: cover;
  flex-shrink: 0;
  background: rgba(0, 0, 0, 0.2);
`

export const IconPlaceholder = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 16px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  background: #5865f2;
  text-transform: uppercase;
`

export const Meta = styled.div`
  min-width: 0;
  flex: 1;
  margin: 0 16px;

  @media (max-width: 420px) {
    margin: 12px 0;
  }
`

export const Name = styled.a`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`

export const Stats = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 4px;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors._primary.fadeOut(0.3).toString()};
`

export const Stat = styled.span`
  display: inline-flex;
  align-items: center;
  margin-right: 12px;
`

export const StatDot = styled.span<{ online?: boolean }>`
  width: 8px;
  height: 8px;
  margin-right: 6px;
  border-radius: 50%;
  background: ${({ online }) => (online ? '#23a559' : '#80848e')};
`

export const JoinButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-width: 72px;
  height: 40px;
  padding: 2px 16px;
  border-radius: 3px;
  background: #248046;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    background: #1a6334;
    color: #fff;
  }

  @media (max-width: 420px) {
    width: 100%;
  }
`



// WEBPACK FOOTER //
// ./src/components/Messages/Message/Embed/elements/invite.ts